import React from 'react';

function FontSizeSelector(props) {
    return (
        <input
            type="number"
            min="10"
            max="99"
            value={props.value}
            onChange={props.onChange}
            style={{ width: '45px', height:'35px', verticalAlign: 'middle'}} // Basic styling for the picker
        />
    );
}

export default FontSizeSelector;